import { Center, Text, useMantineTheme } from '@mantine/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface NoDataProps {
  missing: string
}

const NoData: React.FC<NoDataProps> = ({ missing = 'data' }) => {
  const theme = useMantineTheme()
  const { t } = useTranslation()

  return (
    <Center style={{ margin: '32px', height: 'inherit' }}>
      <Text style={{ alignSelf: 'center', color: theme.colors.paragraph[0] }}>
        {
          t(`components.noData.missing`, 'No {{missing}} yet.', {
            missing,
          }) as string
        }
      </Text>
    </Center>
  )
}

export default NoData
